import EmptyState from '@components/v2/ui/EmptyState/EmptyState';
import OrdersIllustration from '@components/v2/ui/EmptyState/svg/OrdersIllustration';
import { Stack } from '@mui/material';
import LangEnum from '../../../../../../../lang/LangEnum';
import { OrderConditionsTestIds } from '../../../../../../../utils/testIds/OrderConditions.testIds';

const CONTENT_INDENT = 10;

interface OrderConditionsEmptyStateProps {
  isReadOnlyView: boolean;
}

const OrderConditionsEmptyState = ({ isReadOnlyView }: OrderConditionsEmptyStateProps) => (
  <Stack
    sx={{
      justifyContent: 'center',
      alignItems: { xs: 'center', md: 'flex-start' },
      ml: { xs: 0, md: CONTENT_INDENT },
      px: { xs: 3, md: 0 },
    }}
  >
    <EmptyState
      testId={OrderConditionsTestIds.TAB_EMPTY_STATE}
      title={{ text: LangEnum.ORDER_CONDITIONS_EMPTY_TITLE }}
      illustration={<OrdersIllustration />}
      description={{
        text: isReadOnlyView
          ? LangEnum.ORDER_CONDITIONS_EMPTY_READ_ONLY_DESCRIPTION
          : LangEnum.ORDER_CONDITIONS_EMPTY_DESCRIPTION,
      }}
    />
  </Stack>
);

export default OrderConditionsEmptyState;
